import { IPayload } from 'models/Global'
import { IGetCitiesParams, ICity, IPutCityParams, IPostCityParams } from 'models/City'
import { AxiosService } from '../config/config'
import { Endpoints } from '../config/endpoints'

export class CitiesApi {
  constructor(private axios: AxiosService) {}

  getCities = async (params?: IGetCitiesParams) => {
    const response = await this.axios.get<IPayload<ICity[]>>(Endpoints.getCities, params)
    return response
  }

  getCity = async (id: number) => {
    const response = await this.axios.get<IPayload<ICity>>(Endpoints.getCity(id))
    return response
  }

  postCity = async (params: IPostCityParams) => {
    const response = await this.axios.post<IPayload<ICity>>(Endpoints.postCity, params)
    return response
  }

  putCity = async (id: number, params: IPutCityParams) => {
    const response = await this.axios.put<IPayload<ICity>>(Endpoints.putCity(id), params)
    return response
  }

  deleteCity = async (id: number) => {
    const response = await this.axios.delete<{}>(Endpoints.deleteCity(id))
    return response
  }
}
